import { Exercise } from "@domain/exercise/exercise";
import {
	AnalyticsViewExerciseDetailOrigin,
	sendAnalyticsEventViewExerciseDetail,
} from "@domain/library/exercise-analytics";
import { useUser } from "@domain/user/hooks/use-user";
import { DialogContext, ModalId } from "@ui/components/dialog/dialog-provider";
import { TrackingContext } from "@ui/components/common/tracking-context-provider";
import { ExerciseDetailsDialogTabs } from "@ui/pages/program-builder/dialog/exercise-details-dialog";
import { isNotNil } from "@utils/assert";
import { formatName } from "@utils/string-utils";
import { useCallback, useContext } from "react";

interface UseEditorExerciseCardActions {
	openExerciseDetailsModal: (
		exercise: Exercise,
		relatedExercises: Exercise[],
		origin: AnalyticsViewExerciseDetailOrigin,
		selectedTab?: ExerciseDetailsDialogTabs,
	) => void;
}

export const useEditorExerciseCardActions = (): UseEditorExerciseCardActions => {
	const dialogContext = useContext(DialogContext);
	const trackingContext = useContext(TrackingContext);
	const user = useUser();

	const openExerciseDetailsModal = useCallback(
		(
			exercise: Exercise,
			relatedExercises: Exercise[],
			origin: AnalyticsViewExerciseDetailOrigin,
			selectedTab?: ExerciseDetailsDialogTabs,
		) => {
			isNotNil(user) &&
				dialogContext?.openModal(ModalId.ExerciseDetails, {
					relatedExercises,
					exerciseIndex: relatedExercises.findIndex(ex => ex.draggableId === exercise.draggableId),
					selectedTab,
					editable: true,
					trackingContext: trackingContext,
					editorName: formatName(user),
				});
			sendAnalyticsEventViewExerciseDetail(exercise, origin);
		},
	[dialogContext, trackingContext, user],
	);

	return { openExerciseDetailsModal };
};
